import {
  ArrowDownOnSquareIcon,
  ClipboardDocumentIcon,
  EllipsisVerticalIcon,
} from '@heroicons/react/24/solid';
import clsx from 'clsx';
import { useState } from 'react';
import { Button, Toggle } from '../../ui-base';
import { toast } from '../../util';
import MenuDropdown from '../menu-dropdown/MenuDropdown';
import { MenuItem } from '../types';

interface Props {
  title: string;
  description: string;
  isDownloadable?: boolean;
  minimizeOnMobile?: boolean;
  toggleLabel?: string;
  toggleEnabled?: boolean;
  onToggleChange?: (enabled: boolean) => void;
  onExport?: () => void;
  onCopy?: () => void;
}
export function CardPanel(props: Props) {
  const {
    title,
    description,
    isDownloadable = false,
    minimizeOnMobile = false,
    toggleEnabled,
    toggleLabel,
    onToggleChange,
    onExport,
    onCopy,
  } = props;
  const [isDescriptionMinimised, setIsDescriptionMinimised] =
    useState(minimizeOnMobile);
  const onClickFullFile = () => setIsDescriptionMinimised(false);
  const descriptionMaxHeight = isDescriptionMinimised
    ? 'max-h-[15vh]'
    : 'max-h-[40vh]';

  const onCopyCb = () => onCopy && onCopy();

  const onSave = () => {
    onExport && onExport();
    toast('Headnote downloaded as pdf');
  };

  const menuItems: MenuItem[] = [
    {
      name: 'Save',
      onClick: onSave,
    },
    {
      name: 'Copy',
      onClick: onCopyCb,
    },
  ];
  if (onToggleChange) {
    const item = {
      name: toggleEnabled ? 'Show Special Format' : 'Show Standard Format',
      onClick: () => onToggleChange(!toggleEnabled),
    };
    menuItems.push(item);
  }

  return (
    <div className="rounded-md px-2 py-4 shadow-lg">
      <div className="mb-4 flex h-20 items-center justify-between border-b border-gray-400 p-2">
        <h2 className="text-xl font-bold text-gray-700">{title}</h2>
        {onToggleChange && (
          <div className="hidden lg:block">
            <Toggle
              enabled={!!toggleEnabled}
              onChange={onToggleChange}
              label={toggleLabel}
            />
          </div>
        )}
        {isDownloadable && (
          <>
            <div className="hidden items-center text-lawmatrix-purple lg:flex">
              <Button
                onClick={onSave}
                variant="icon"
                className="flex items-center"
              >
                Save
                <ArrowDownOnSquareIcon className="h-6 w-8" />
              </Button>
              <Button
                onClick={onCopy}
                variant="icon"
                className="flex items-center"
              >
                Copy
                <ClipboardDocumentIcon className="h-6 w-8" />
              </Button>
            </div>
            <div className="block lg:hidden">
              <MenuDropdown
                menuButton={<EllipsisVerticalIcon className="h-5 w-5" />}
                items={menuItems}
              />
            </div>
          </>
        )}
      </div>
      <p
        className={clsx(
          'overflow-y-auto whitespace-pre-line p-3 lg:max-h-[60vh]',
          descriptionMaxHeight,
        )}
        dangerouslySetInnerHTML={{ __html: description }}
      >
        {/* {description} */}
      </p>
      {isDescriptionMinimised && (
        <div className="mt-2 text-center">
          <button
            className="text-lawmatrix-purple underline lg:hidden"
            onClick={onClickFullFile}
          >
            View full file
          </button>
        </div>
      )}
    </div>
  );
}

export default CardPanel;
